import { render, staticRenderFns } from "./Quintas.vue?vue&type=template&id=1ca718c0&scoped=true&"
import script from "./Quintas.vue?vue&type=script&lang=js&"
export * from "./Quintas.vue?vue&type=script&lang=js&"
import style0 from "./Quintas.vue?vue&type=style&index=0&id=1ca718c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca718c0",
  null
  
)

export default component.exports